
<section class="fixed-height parallaxBg bg-img" data-bg="assets/img/verificacion/fondo-verificacion.jpg" style="background-image: url('assets/img/verificacion/fondo-verificacion.jpg')">
  <div class="container h-100">
    <div class="row align-items-center h-100">
      <div class="col-lg-7 text-center m-auto">
        <div class="about-us-content white mt-100">
          <h3 style="color: white">
            Componente de Verificación Proyecto IOARR
          </h3>
        </div>
      </div>
    </div>
  </div>
</section>
<section class="team-area-wrapper bg-offwhite pt-80 pt-md-80 pt-sm-60 pb-40 pb-md-80 pb-sm-60" style="background-image: url('/assets/img/fondo-rosario-2.png'); background-size: cover;
    background-position: center;">
  <div class="container">
      <div class="row">
          <div class="col-lg-6 text-center">
              <div class="">
                  <h2>VERIFICACIÓN DE INFORMACIÓN CONTROL DE CALIDAD</h2>
                  <p class="m-0" style="font-size: 16px; line-height: 1.9;">La Gerencia del Centro Histórico del Cusco
                  mediante el proyecto IOARR: “ADQUISICIÓN DE SISTEMA DE INFORMACIÓN; EN EL (LA) OPTIMIZACIÓN DEL SISTEMA DE
                  INFORMACIÓN DEL SERVICIO DE CATALOGACIÓN DE INMUEBLES DEL CENTRO HISTÓRICO, DISTRITO CUSCO,
                  PROVINCIA DE CUSCO, DEPARTAMENTO CUSCO”. <br> Tiene como parte importante de las actividades desarrolladas
                  la verificación de la información catalogada en la fichas desarrolladas en la catalogación del 2010 - 2013, 2018 y
                  y los nuevos inmuebles y ambientes urbanos catalogados en este proyecto del 2019 - 2021. Por lo cual esta labor fue desarrollada
                  por el componente de verificación.

                  </p>
              </div>
          </div>
          <div class="col-lg-6 text-center">
              <div class="speaker-member-wrap mt-sm-10" style="margin-top:-20px;">
                <figure class="speaker-thumbnail">
                    <img src="assets/img/verificacion/mylene.jpg"
                        alt="GERENCIA DEL CENTRO HISTÓRICO"
                        style="width: 300px; display: block; margin: 0 auto;">
                </figure>
                <div class="speaker-info">
                    <h3 style="text-align: center;">ARQ. MYLENE RYLDA ARIZABAL CALDERON</h3>
                    <h6 class="designation mb-20" style="text-align: center;">COORDINADORA COMPONENTE DE VERIFICACIÓN</h6>
                </div>
            </div>
          </div>
      </div>
  </div>
</section>

<section id="landing-service-area-wrapper" class="pt-68 pt-md-26 pt-sm-20 pb-114 pb-md-76 pb-sm-56" style="background-image: url('/assets/img/verificacion/fondo-torito2.png'); ">
  <div class="container">

    <div class="row">
      <div class="col-lg-12 text-center" style="margin-bottom:-60px;">
        <div class="section-title-wrap">
          <h3 style="color:white">Actividades del Componente verificación</h3>
        </div>
      </div>
      <!-- Single Service Item #1 -->
      <div class="col-md-12 col-lg-12">
        <div class="single-service-wrap d-flex">
          <span class="service-icon"><i class="fa fa-angle-double-right"></i></span>
          <div class="service-info">
            <h3>Verificación</h3>
            <p class="m-0">
            Se cumplió con la actividad ya señalada en lo que se refiere a la Verificación y contratación de Fichas impresas y digitales de catalogación en un
            total 14,256 FICHAS (Ficha de registro Arquitectura, Ficha de registro fotográfico de Arquitectura, Ficha de registro Arqueológico, Ficha de registro
            fotográfico de Arqueología, Ficha de registro Histórico, Ficha de registro legal, planos y descripciones de ambientes urbanos) de acuerdo al siguiente detalle:
            </p>
            <ul>
              <li><i class="fa fa-play"></i> Fichas de catalogación de inmuebles civil/domestico 12,943</li>
              <li><i class="fa fa-play"></i> Fichas de catalogación de inmuebles religiosos 393</li>
              <li><i class="fa fa-play"></i> Fichas de Ambientes urbanos calles 764</li>
              <li><i class="fa fa-play"></i> Fichas de Ambientes urbanos plazas 156</li>
            </ul>
          </div>
        </div>
      </div>
      <!-- Single Service Item #2 -->
      <div class="col-md-4 col-lg-4">
        <div class="single-service-wrap d-flex">
          <span class="service-icon"></span>
          <div class="service-info">
            <img src="assets/img/verificacion/2014.JPG" alt="">
          </div>
        </div>
      </div>

      <div class="col-md-4 col-lg-4">
        <div class="single-service-wrap d-flex">
          <span class="service-icon"></span>
          <div class="service-info">
            <img src="assets/img/verificacion/2018.JPG" alt="">
          </div>
        </div>
      </div>

      <div class="col-md-4 col-lg-4">
        <div class="single-service-wrap d-flex">
          <span class="service-icon"></span>
          <div class="service-info">
            <img src="assets/img/verificacion/2021.JPG" alt="">
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<section class="team-member-area bg-offwhite pt-120 pt-md-80 pt-sm-60 pb-120 pb-md-80 pb-sm-60" style="background-image: url('/assets/img/gerencia/fondo-gerencia.png'); background-size: cover; background-position: center;">
  <div class="container">
    <div class="row">
      <!-- Start Section title -->
      <div class="col-lg-6 m-auto text-center">
        <div class="section-title-wrap">
          <h2>Equipo de trabajo</h2>
          <p class="mb-0">El componente de verificación contó con el siguiente equipo de trabajo.</p>
        </div>
      </div><!-- End Section title -->
    </div>
    <div class="row mtm-50 mtm-sm-30">
      <!-- Start Team Member #01 -->
      <div class="col-lg-4 col-sm-6">
        <div class="speaker-member-wrap">
          <figure class="speaker-thumbnail"><img src="assets/img/verificacion/andres.jpg" alt="Team"></figure>
          <div class="speaker-info">
            <h3>Br. Arq. ANDRES GERARDO PINEDA ESPINOZA</h3>
            <h6 class="designation">Cargo: Verificador</h6>
          </div>
        </div>
      </div><!-- Start Team Member #02 -->
      <div class="col-lg-4 col-sm-6">
        <div class="speaker-member-wrap">
          <figure class="speaker-thumbnail"><img src="assets/img/verificacion/percy.jpg" alt="Team"></figure>
          <div class="speaker-info">
            <h3>Br. Arq. JUAN PERCY CCOLQQUE LAURA</h3>
            <h6 class="designation">Cargo: Verificador</h6>
          </div>
        </div>
      </div><!-- Start Team Member #03 -->
      <div class="col-lg-4 col-sm-6">
        <div class="speaker-member-wrap">
          <figure class="speaker-thumbnail"><img src="assets/img/verificacion/keny.jpg" alt="Team"></figure>
          <div class="speaker-info">
            <h3>Br. Arq. ENNY CHOQUE INCACUTIPA</h3>
            <h6 class="designation">Cargo: Verificador</h6>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<div class="page-wrapper">
  <article class="port-details-page-wrap">
      <div class="port-details-header">
          <div class="ht-slick-slider portfolio-thumbnail-inner" data-slick='{"slidesToShow": 5, "responsive": [{"breakpoint": 991,"settings": {"dots": false,"slidesToShow": 3}}, {"breakpoint": 575,"settings": {"slidesToShow": 2}}]}'>
              <figure class="port-details-thumb-item">
                <a href="assets/img/verificacion/verificacion03.jpg" class="btn-img-gallery">
                    <img src="assets/img/verificacion/verificacion03.jpg" alt="Portfolio">
                </a>
              </figure>
              <figure class="port-details-thumb-item">
                <a href="assets/img/verificacion/verificacion05.jpg" class="btn-img-gallery">
                    <img src="assets/img/verificacion/verificacion05.jpg" alt="Portfolio">
                </a>
              </figure>
              <figure class="port-details-thumb-item">
                <a href="assets/img/verificacion/verificacion04.jpg" class="btn-img-gallery">
                    <img src="assets/img/verificacion/verificacion04.jpg" alt="Portfolio">
                </a>
              </figure>
              <figure class="port-details-thumb-item">
                <a href="assets/img/verificacion/verificacion08.jpg" class="btn-img-gallery">
                    <img src="assets/img/verificacion/verificacion08.jpg" alt="Portfolio">
                </a>
              </figure>
              <figure class="port-details-thumb-item">
                  <a href="assets/img/verificacion/verificacion01.jpg" class="btn-img-gallery">
                      <img src="assets/img/verificacion/verificacion01.jpg" alt="Portfolio">
                  </a>
              </figure>
              <figure class="port-details-thumb-item">
                <a href="assets/img/verificacion/verificacion07.jpg" class="btn-img-gallery">
                    <img src="assets/img/verificacion/verificacion07.jpg" alt="Portfolio">
                </a>
              </figure>
              <figure class="port-details-thumb-item">
                <a href="assets/img/verificacion/verificacion02.jpg" class="btn-img-gallery">
                    <img src="assets/img/verificacion/verificacion02.jpg" alt="Portfolio">
                </a>
              </figure>
              <figure class="port-details-thumb-item">
                <a href="assets/img/verificacion/verificacion06.jpg" class="btn-img-gallery">
                    <img src="assets/img/verificacion/verificacion06.jpg" alt="Portfolio">
                </a>
              </figure>
          </div>
      </div>
  </article>
</div>

